webpackJsonp([10],{

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = IconAddAlert;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function IconAddAlert(props) {
  const size = props.size,
        style = props.style,
        rest = _objectWithoutProperties(props, ['size', 'style']);

  const baseStyles = {};

  if (size) {
    baseStyles['--_mt-iconSize'] = size;
  }

  const styleToApply = _extends({}, baseStyles, {
    width: 'var(--_mt-iconSize, 1em)',
    height: 'var(--_mt-iconSize, 1em)'
  }, style);

  return _react2.default.createElement(
    'svg',
    _extends({ xmlns: 'http://www.w3.org/2000/svg', style: styleToApply, viewBox: '0 0 48 48' }, rest),
    ' ',
    _react2.default.createElement('path', { d: 'M20.02 41.02c0 2.2 1.78 3.98 3.98 3.98s3.98-1.78 3.98-3.98h-7.96zm17.74-8.38V21c0-6.5-4.5-11.94-10.58-13.38V6.18C27.18 4.42 25.76 3 24 3s-3.18 1.42-3.18 3.18v1.44C14.74 9.06 10.24 14.5 10.24 21v11.64L6 36.88V39h36v-2.12l-4.24-4.24zM32 25.01h-6v6h-4v-6h-6V21h6v-6h4v6h6v4.01z' })
  );
}

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Buttons = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(14);

var _materialish = __webpack_require__(59);

var _iconAddAlert = __webpack_require__(315);

var _iconAddAlert2 = _interopRequireDefault(_iconAddAlert);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Buttons = exports.Buttons = function (_Component) {
  _inherits(Buttons, _Component);

  function Buttons() {
    _classCallCheck(this, Buttons);

    return _possibleConstructorReturn(this, (Buttons.__proto__ || Object.getPrototypeOf(Buttons)).apply(this, arguments));
  }

  _createClass(Buttons, [{
    key: 'render',
    value: function render() {
      var component = this.props.component;
      var materialDocsLink = component.materialDocsLink;


      return _react2.default.createElement(
        'div',
        { className: 'componentDoc' },
        _react2.default.createElement(
          'h1',
          { className: 'primaryHeader componentDoc_primaryHeader' },
          'Buttons'
        ),
        _react2.default.createElement(
          'p',
          { className: 'paragraph' },
          'Buttons represent that an action will occur when the user clicks or touches them.'
        ),
        _react2.default.createElement(
          _materialish.Table,
          { className: 'componentDoc_componentsTable' },
          _react2.default.createElement(
            _materialish.Table.Head,
            null,
            _react2.default.createElement(
              _materialish.Table.HeadRow,
              null,
              _react2.default.createElement(
                _materialish.Table.HeadCell,
                { width: '170px' },
                'Preview'
              ),
              _react2.default.createElement(
                _materialish.Table.HeadCell,
                { width: '150px' },
                'Name'
              ),
              _react2.default.createElement(
                _materialish.Table.HeadCell,
                null,
                'Description'
              )
            )
          ),
          _react2.default.createElement(
            _materialish.Table.Body,
            null,
            _react2.default.createElement(
              _materialish.Table.Row,
              null,
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                _react2.default.createElement(
                  _materialish.Button,
                  null,
                  'Click Me'
                )
              ),
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                _react2.default.createElement(
                  _reactStatic.Link,
                  { to: '/components/button' },
                  'Button'
                )
              ),
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                'a button that has text, and may optionally also include an icon'
              )
            ),
            _react2.default.createElement(
              _materialish.Table.Row,
              null,
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                _react2.default.createElement(
                  _materialish.IconButton,
                  null,
                  _react2.default.createElement(_iconAddAlert2.default, null)
                )
              ),
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                _react2.default.createElement(
                  _reactStatic.Link,
                  { to: '/components/icon-button' },
                  'Icon Button'
                )
              ),
              _react2.default.createElement(
                _materialish.Table.Cell,
                null,
                'a round button with an icon, and no text'
              )
            )
          )
        ),
        _react2.default.createElement(
          'h2',
          { className: 'secondaryHeader componentDoc_standaloneSecondaryHeader' },
          'Useful Links'
        ),
        _react2.default.createElement(
          'ul',
          { className: 'componentDoc_links' },
          _react2.default.createElement(
            'li',
            { className: 'componentDoc_linkItem' },
            _react2.default.createElement(
              'a',
              { href: materialDocsLink, className: 'componentDoc_linkAnchor' },
              _react2.default.createElement('i', { className: 'componentDoc_icon zmdi zmdi-file-text' }),
              ' Material Guidelines'
            )
          )
        )
      );
    }
  }]);

  return Buttons;
}(_react.Component);

exports.default = (0, _reactStatic.withRouteData)(Buttons);

/***/ })

});


// WEBPACK FOOTER //
// templates/src/components/buttons.ad10c5fb.js